<!-- THE WRAPPER DIV IS NEEDED IN ORDER TO USE THE PRELOAD-IMAGE DIRECTIVE -->
@if (firstImage | async; as image) {
<div
  class="opacity-container"
  [ngClass]="image.classes"
  [style.opacity]="(firstVisible | async) ? '1' : '0'"
>
  @if (firstTranslate | async) {
  <h1 class="h1 ellipsis title">
    <span>{{ firstTitle | async | transloco }}</span>
  </h1>

  <h2 class="h5 title">
    <span>{{ firstSubtitle | async | transloco }}</span>
  </h2>
  } @else {
  <h1 class="h1 ellipsis">
    <span>{{ firstTitle | async }}</span>
  </h1>

  <h2 class="h5">
    <span>{{ firstSubtitle | async }}</span>
  </h2>
  } @if (showImage) {
  <div class="background" [preloadImage]="image.imageUrl"></div>
  }
</div>
}

<!-- THE WRAPPER DIV IS NEEDED IN ORDER TO USE THE PRELOAD-IMAGE DIRECTIVE -->
@if (secondImage | async; as image) {
<div
  class="opacity-container"
  [ngClass]="image.classes"
  [style.opacity]="(firstVisible | async) ? '0' : '1'"
>
  @if (secondTranslate | async) {
  <h1 class="h1 ellipsis title">
    <span>{{ secondTitle | async | transloco }}</span>
  </h1>

  <h2 class="h5 title">
    <span>{{ secondSubtitle | async | transloco }}</span>
  </h2>
  } @else {
  <h1 class="h1 ellipsis">
    <span>{{ secondTitle | async }}</span>
  </h1>

  <h2 class="h5">
    <span>{{ secondSubtitle | async }}</span>
  </h2>
  }

  <div class="background" [preloadImage]="image.imageUrl"></div>
</div>
}
